'use client';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface ErrorMessageProps {
    message: string;
    title?: string;
    className?: string;
}

/**
 * A reusable error message component
 */
export default function ErrorMessage({
    message,
    title = 'Fout opgetreden',
    className,
}: ErrorMessageProps) {
    return (
        <Alert variant="destructive" className={className}>
            <AlertTitle>{title}</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
        </Alert>
    );
}
